import { render, staticRenderFns } from "./MyBonus.vue?vue&type=template&id=6d52034a"
import script from "./MyBonus.vue?vue&type=script&lang=js"
export * from "./MyBonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports